import React from "react";
import Testimonial from "./Testimonial/Testimonial";
import "./HomeSectionSeven.css";
import TestimonialSlider from "./Slider/Slider";

function HomeSectionSeven() {
  return (
    <div className="homeSectionSeven">
      <div className="HomeSectionSeven__Title">
        <h3>Trusted by Thousands of Happy Customer</h3>
      </div>

      <div className="HomeSectionSeven__subTitle">
        <p>
          These are the stories of our customers who have joined us with great
          pleasure when using this crazy feature
        </p>
      </div>

      <div className="HomeSectionSeven__testimonial">
        <TestimonialSlider />
      </div>

      {/* <div className="HomeSectionSeven__navigation">
        <div className="HomeSectionSeven__navigation--steps">
          <li>heyy</li>
          <li>heyy</li>
          <li>heyy</li>
        </div>
        <div className="HomeSectionSeven__navigation--buttons">
          <button>Prev</button>
          <button>Next</button>
        </div>
      </div> */}
    </div>
  );
}

export default HomeSectionSeven;
